import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Code, ConnectError } from '@connectrpc/connect';
import { SpecraButton, SpecraCheckbox, SpecraInlineBanner, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
/** The server's words for a refused surgery; a stubbed gateway reads as "not available yet". */ export function surgeryErrorText(error) {
    if (error instanceof ConnectError) {
        if (error.code === Code.Unimplemented || error.code === Code.Unavailable) return 'Splits and merges are not available on this deployment yet.';
        return error.rawMessage || 'The change could not be saved.';
    }
    return error instanceof Error ? error.message : 'The change could not be saved.';
}
export function SurgeryError({ error }) {
    if (!error) return null;
    return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
        tone: "danger",
        variant: "framed",
        "data-testid": Testids.pursuitSurgery.error,
        children: surgeryErrorText(error)
    });
}
/**
 * The proposal-review warning + required acknowledgement (GRW-19): shown when
 * the selection moves an RFI response or a proposal link and the server says
 * a proposal of this pursuit keeps its RFI responses.
 */ export function ReviewAck({ proposals, verb, checked, onCheckedChange }) {
    const names = proposals.map((p)=>p.label).filter(Boolean);
    const subject = names.length ? `Proposal ${names.join(', ')}` : 'A proposal of this pursuit';
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
                tone: "warning",
                variant: "framed",
                children: [
                    subject,
                    " keeps its RFI responses. Review the proposal after this ",
                    verb,
                    "."
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraCheckbox, {
                        id: `review-ack-${verb}`,
                        checked: checked,
                        onCheckedChange: (v)=>onCheckedChange(v === true),
                        "aria-label": "I'll review the proposal",
                        "data-testid": Testids.pursuitSurgery.reviewAck
                    }),
                    /*#__PURE__*/ _jsx(SpecraText, {
                        size: "body-ui",
                        children: "I'll review the proposal"
                    })
                ]
            })
        ]
    });
}
export function SurgeryFooterActions({ onCancel, onSubmit, disabled, pending, label }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex justify-end gap-2",
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "secondary",
                onClick: onCancel,
                children: "Cancel"
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                onClick: onSubmit,
                disabled: disabled,
                "data-testid": Testids.pursuitSurgery.submit,
                children: pending ? 'Saving…' : label
            })
        ]
    });
}
